if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slides = Array.from(this.querySelectorAll('[data-irp-modal-slide]'));
        this.previousButton = this.querySelector('[data-irp-modal-previous]');
        this.nextButton = this.querySelector('[data-irp-modal-next]');
        this.currentElement = this.querySelector('[data-irp-modal-current]');

        [this.previousButton, this.nextButton].filter(Boolean).forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.previousButton?.addEventListener('click', () => this.showRelativeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showRelativeMedia(1));
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showRelativeMedia(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showRelativeMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const requestedMediaId = this.openedBy.getAttribute('data-media-id');
        const requestedIndex = this.slides.findIndex((slide) => slide.getAttribute('data-media-id') === requestedMediaId);
        this.showMedia(requestedIndex >= 0 ? requestedIndex : 0);
      }

      showRelativeMedia(direction) {
        if (this.slides.length < 2) return;
        const currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('active')));
        this.showMedia((currentIndex + direction + this.slides.length) % this.slides.length);
      }

      showMedia(index) {
        const activeMedia = this.slides[index];
        if (!activeMedia) return;
        window.pauseAllMedia();
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (this.currentElement) this.currentElement.textContent = String(index + 1);

        if (
          activeMedia.querySelector('deferred-media') &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.querySelector('deferred-media').loadContent();
      }
    }
  );
}
